import moment from "moment";
import React from "react";

type Props = {
  currentMsgId: string;
  lastMsgId: string;
  currentMsgDate: string;
  lastMsgDate: string;
};

const DateHeader: React.FC<Props> = (props: Props) => {
  const { currentMsgId, lastMsgId, currentMsgDate, lastMsgDate } = props;

  if (
    currentMsgId === lastMsgId ||
    moment(currentMsgDate).format("DD MMMM YYYY, dddd") !==
      moment(lastMsgDate).format("DD MMMM YYYY, dddd")
  ) {
    var messageDate = moment(currentMsgDate).format("DD MMMM YYYY, dddd");
  } else {
    return null;
  }

  return (
    <div className="date-separator">
      <hr />
      <span className="leading-para">{messageDate}</span>
    </div>
  );
};

export default DateHeader;
